<template>
  <div class="container">
    <div class="shop_top no_nav">
      <custom-head :title="lang.checkout_page" :nav_show="false" />
    </div>
    <div class="width_center_1200">
      <div class="order-tips">
        <span>{{ lang.fill_tips }}</span>
      </div>
      <div class="order-content">
        <!-- 月卡信息 -->
        <div v-if="id" class="self-mention">
          <el-image :src="info.xmcardimg" lazy fit="cover"></el-image>
          <div class="cont flex-align">
            <div class="name">{{ info.xmcardname }}</div>
          </div>
        </div>
        <template v-else>
          <!-- 自助机信息 -->
          <div v-if="info.vedinfo" class="self-mention">
            <el-image :src="info.vedinfo.vemimg" lazy fit="cover"></el-image>
            <div class="cont">
              <div class="name">{{ info.vedinfo.vemName }}</div>
              <div class="address">{{ info.vedinfo.vemaddress }}</div>
            </div>
          </div>
        </template>
        <!-- 月卡赠送 -->
        <div class="pay-type">
          <div class="card-input flex-align">
            <div class="card-input__label">{{ lang.card_txt1 }}</div>
            <div class="card-input__cont">
              <el-radio-group
                v-model="info.givestype"
              >
                <el-radio :label="1">{{ lang.card_txt2 }}</el-radio>
                <el-radio :label="0">{{ lang.card_txt3 }}</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div v-if="info.givestype === 1" class="card-input flex-align">
            <div class="card-input__label">{{ lang.card_txt4 }}：</div>
            <div class="card-input__cont">
              <el-input v-model="info.givephoneorder" :placeholder="lang.card_txt5" />
            </div>
          </div>
        </div>
        <!-- 支付方式 -->
        <div class="pay-type">
          <div class="title">{{ lang.paytype }}</div>
          <ul>
            <li v-for="(item, index) in payType.list" :key="index" @click="payType.index = index">
              <div class="check-box" :class="{ 'cur': index === payType.index }"></div>
              <img :src="item.paylogo" />
              <span>{{ item.payname }}</span>
            </li>
          </ul>
        </div>
        <!-- 商品清单 -->
        <div class="goods-info">
          <div class="title">{{ lang.goods_list }}</div>
          <ul
            :class="showGoods ? 'show' : ''"
            :style="{maxHeight: showGoods ? goodsHeight : '333px'}"
          >
            <li
              v-for="item in info.orderitem"
              :key="item.id"
              @click.stop="info.hdtype !== 11 && $router.push(`/goods/info/${item.productno}`)"
            >
              <el-image :src="item.productimg" lazy></el-image>
              <div class="cont">
                <div class="name">{{ item.productname }}</div>
                <div class="desc">{{ item.briefName }}</div>
                <div class="bottom">
                  <div v-if="item.integral > 0" class="price">
                    {{ unit }}
                    <span>{{ item.productprice.toFixed(2) }}</span> + <span>{{ item.integral }}{{ lang.integral }}</span>
                  </div>
                  <div v-else class="price">
                    <template v-if="info.hdtype === 11">{{ $t('card').value }}</template>{{ unit }}
                    <span>{{ item.productprice.toFixed(2) }}</span>
                  </div>
                  <div v-if="info.hdtype !== 11" class="num">x{{ item.productnum }}</div>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="info.orderitem.length > 3" class="toggle-box" @click="showGoods =! showGoods">
            {{ showGoods ? lang.putaway : lang.expand }}
            <i :class="showGoods ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
          </div>
        </div>
        <!-- 优惠券 -->
        <div v-if="info.hdtype === 0" class="coupon-select">
          <div class="title">{{ lang.coupon }}</div>
          <div class="coupon-cont" @click="couponData.show = couponData.list.length ? true : false">
            <template v-if="couponData.info.id">
              <span class="name">{{ couponData.info.name }}</span>
              <span class="tips">{{ lang.edit }}</span>
            </template>
            <template v-else>
              <span
                v-if="couponData.list.length"
              >{{ couponData.list.length }}{{ lang.coupon_available }}</span>
              <span v-else class="tips">{{ lang.no_available }}</span>
            </template>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <!-- 商品信息 -->
        <div class="order-info">
          <ul>
            <li v-if="info.totalmoneydoor">
              <div class="name">{{ lang.original_price }}</div>
              <div class="value">
                <span>{{ unit }}</span>
                {{ info.totalmoneydoor.toFixed(2) }}
              </div>
            </li>
            <li>
              <div class="name">{{ lang.amount }}</div>
              <div v-if="info.totalmoney" class="value">
                <span>{{ unit }}</span>
                {{ info.totalmoney.toFixed(2) }}
              </div>
            </li>
            <li v-if="info.discountmoney">
              <div class="name">{{ lang.coupon }}</div>
              <div class="value">
                <span>-{{ unit }}</span>
                {{ info.discountmoney }}
              </div>
            </li>
            <li v-if="info.paypoint > 0">
              <div class="name">{{ lang.paypoint }}</div>
              <div class="value">{{ info.paypoint }} </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="totalPrice" class="order-bottom">
        <div class="total-box">
          <div class="name">{{ lang.total }}：</div>
          <div v-if="info.paypoint > 0" class="money">
            {{ unit }}
            <span>{{ totalPrice }}</span> + <span>{{ info.paypoint }}{{ lang.integral }}</span>
          </div>
          <div v-else class="money">
            {{ unit }}
            <span>{{ totalPrice > 0 ? totalPrice : '0.00' }}</span>
          </div>
        </div>
        <div class="action-btns">
          <div class="item-btn" @click="settle">{{ showPayDialog ? lang.payments : lang.settle }}</div>
        </div>
      </div>
    </div>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
    <!-- 支付弹窗 -->
    <el-dialog
      class="pay-dialog"
      :visible.sync="showPayDialog"
      :close-on-click-modal="false"
      width="30%"
    >
      <div class="pay-tips">{{ lang.pay_tips }}</div>
      <i class="el-icon-loading" />
      <div class="loading-text">{{ lang.payments_progress }}</div>
      <div
        class="btn"
        @click="$router.push(`/order/detail?orderno=${payDialogOrderNo}`)"
      >{{ lang.view_order_detail }}</div>
    </el-dialog>
    <!-- 优惠券弹窗 -->
    <el-dialog
      class="coupon-dialog"
      :visible.sync="couponData.show"
      :close-on-click-modal="false"
      :title="lang.select_coupon"
      width="1050px"
    >
      <div class="coupon-list">
        <div
          v-for="item in couponData.list"
          :key="item.id"
          class="item"
          @click="selectCoupon(item)"
        >
          <div class="left">
            <div class="money">
              {{ unit }}
              <span>{{ item.money }}</span>
            </div>
            <div
              class="fullmoney"
            >{{ lang.full_text }}{{ item.fullmoney }}{{ unit }}{{ item.available }}</div>
          </div>
          <div class="right">
            <div class="name">{{ item.name }}</div>
            <div class="time">{{ lang.validity_period }}：{{ item.endtime }}</div>
          </div>
          <div
            class="check-box"
            :class="{ cur : couponData.info.fj_couponuserno === item.fj_couponuserno}"
          ></div>
        </div>
        <div v-for="item in couponData.unList" :key="item.id" class="item disabeld">
          <div class="left">
            <div class="money">
              {{ unit }}
              <span>{{ item.money }}</span>
            </div>
            <div
              class="fullmoney"
            >{{ lang.full_text }}{{ item.fullmoney }}{{ unit }}{{ item.available }}</div>
          </div>
          <div class="right">
            <div class="name">{{ item.name }}</div>
            <div class="time">{{ lang.validity_period }}：{{ item.endtime }}</div>
          </div>
          <div class="check-box"></div>
        </div>
      </div>
      <div class="action-box">
        <el-button size="medium" type="warning" @click="selectCoupon({})">{{ lang.no_use }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomHead from '@/components/CustomHead/index'
import ShopFoot from '@/components/ShopFoot/index'
import {
  getbuycartdetail,
  getbuydetail,
  addorder,
  getpayurl,
  getbuycardorderinfo
} from '@/api/order'
import { getqueryorderstate } from '@/api/orderuser'
import { getbocpaylist, getSysConfig, getagreement } from '@/api/home'
import { getcouponlist } from '@/api/user'
export default {
  components: {
    CustomHead,
    ShopFoot
  },
  data() {
    return {
      payType: {
        list: [],
        index: 0
      },
      delivery: {
        list: [
          {
            name: this.$t('order_confirm').pickup,
            value: 0
          }
        ],
        index: 0
      },
      config: {},
      info: {
        orderitem: [],
        orderptype: 1,
        ordersource: 3,
        givestype: 0
      },
      showGoods: false,
      dialogVisible: false,
      loading: false,
      showPayDialog: false,
      payDialogOrderNo: '',
      timer: '',
      couponData: {
        show: false,
        info: {},
        list: [],
        unList: []
      },
      confirmPop: {
        agree: false,
        title: '',
        contents: ''
      }
    }
  },
  computed: {
    lang() {
      return this.$t('order_confirm')
    },
    id() {
      return this.$route.query.id
    },
    ids() {
      return this.$route.query.ids
    },
    productno() {
      return this.$route.query.productno
    },
    buynum() {
      return this.$route.query.buynum
    },
    goodsHeight() {
      return this.info.orderitem.length * 111 + 'px'
    },
    totalPrice() {
      return (this.info.totalmoney - this.info.discountmoney).toFixed(2)
    },
    ...mapGetters(['isLogin', 'location', 'unit'])
  },
  async created() {
    this.init()
    this.getAgreement()
    this.getPayList()
  },
  methods: {
    async init() {
      let info = {}
      if (this.id) {
        info = await getbuycardorderinfo({
          id: this.id
        })
      } else if (this.productno) {
        info = await getbuydetail({
          productno: this.productno,
          buynum: this.buynum,
          hdtype: this.$route.query.isgift
        })
      } else {
        info = await getbuycartdetail({
          cartids: this.ids,
          ...this.location
        })
      }
      info.data.ispeisong = 0
      this.info = info.data
      this.getMyCoupon()
      getSysConfig().then(({ data }) => {
        this.config = data
      })
    },
    async getAgreement() {
      const { data } = await getagreement({
        keyword: 'submityuekakey'
      })
      Object.assign(this.confirmPop, {
        title: data.title,
        contents: data.contents
      })
    },
    // 获取我的优惠券
    async getMyCoupon() {
      const { data } = await getcouponlist({
        states: 0
      })
      const goodsIds = this.info.orderitem.map(item => item.productno)
      const goodsVemId = this.info.orderitem.map(item => item.vemId)
      data.forEach((item) => {
        // 优惠券的productno
        const productnoList = item.productno ? JSON.parse(item.productno) : []
        const condition = this.totalPrice >= item.fullmoney
        const conditionGoodsIds = productnoList.filter(item => goodsIds.indexOf(item.productno) > -1)
        const conditionGoodsVemId = productnoList.filter(item => goodsVemId.indexOf(item.vemId) > -1)
        if (condition && item.isappoint === 0 ||  condition && conditionGoodsIds.length && conditionGoodsVemId.length) {
          this.couponData.list.push(item)
        } else {
          this.couponData.unList.push(item)
        }
      })
    },
    // 选择优惠券
    selectCoupon(item) {
      this.couponData.info = item
      this.info.discountmoney = parseFloat(item.money) || 0
      this.info.fj_couponuserno = item.fj_couponuserno || ''
      this.couponData.show = false
    },
    // 获取支付方式
    getPayList() {
      getbocpaylist({
        platform: this.$platform
      }).then(({ data }) => {
        this.payType.list = data
      })
    },
    handleConnfirm() {
      Object.assign(this.confirmPop, {
        agree: true
      })
      this.settle()
    },
    // 去结算
    async settle() {
      this.info.ordersource = 3
      // 支付费用
      this.info.totalpaymoney = this.totalPrice
      // 支付方式
      this.info.paytype = this.payType.list[this.payType.index].paytype
      if (this.info.hdtype === 11 && !this.confirmPop.agree) {
        this.$alert(this.confirmPop.contents, this.confirmPop.title, {
          dangerouslyUseHTMLString: true,
          showCancelButton: true
        }).then(() => {
          this.handleConnfirm()
        })
        return
      }
      try {
        const { data } = await addorder(this.info)
        if (data.paystates) {
          this.$router.push(`/order/detail?orderno=${data.orderno}`)
        } else {
          const pay = await getpayurl({
            orderno: data.orderno,
            referUrl: '/user/index',
            ordersource: 3
          })
          this.showPayDialog = true
          this.payDialogOrderNo = data.orderno
          window.open(pay.data.payUrl, '_blank')
          if (pay.code === 1) {
            this.timer = setInterval(() => {
              this.getPayState(data.orderno)
            }, 5000)
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 获取支付状态
    getPayState(orderno) {
      getqueryorderstate({
        orderno: orderno
      }).then(({ data }) => {
        if (data.ispay === 1) {
          clearInterval(this.timer)
          this.$router.push(`/order/detail?orderno=${orderno}`)
        }
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background: #fff;
}
.order-tips {
  height: 50px;
  line-height: 50px;
  color: #000000;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.check-box {
  width: 12px;
  height: 12px;
  border: 1px solid #ec9221;
  border-radius: 50%;
  &.cur {
    background: #ec9221;
  }
}
.order-content {
  margin-bottom: 15px;
  border: 1px solid #eeeeee;
  padding: 15px;
  .title {
    font-size: 14px;
    color: #000;
    line-height: 30px;
  }
  .self-mention {
    display: flex;
    padding-bottom: 15px;
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 20px;
    .el-image {
      width: 68px;
      height: 40px;
      border-radius: 4px;
    }
    .cont {
      margin-left: 15px;
      .name {
        color: #000;
        font-size: 14px;
      }
      .address {
        color: #aaa;
        font-size: 14px;
      }
    }
  }
  .receiver-box {
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 20px;
    .head {
      display: flex;
      justify-content: space-between;
      .action-box {
        display: flex;
        align-items: center;
        li {
          color: #ec9221;
          font-size: 14px;
          margin-left: 30px;
          cursor: pointer;
        }
      }
    }
    ul {
      li {
        display: flex;
        align-items: center;
        cursor: pointer;
        padding-bottom: 30px;
        span {
          color: #4f4f4f;
          font-size: 12px;
          padding-left: 20px;
          &.default {
            color: #ec9221;
          }
        }
      }
    }
  }
  .pay-type {
    margin-bottom: 20px;
    border-bottom: 1px solid #eeeeee;
    ul {
      display: flex;
      align-items: center;
      padding: 8px 0 24px;
      li {
        display: flex;
        align-items: center;
        margin-right: 24px;
        cursor: pointer;
        img {
          width: 24px;
          height: 24px;
          margin: 0 10px;
        }
        span {
          font-size: 14px;
          color: #000;
        }
      }
    }
  }
  .goods-info {
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 40px;
    ul {
      position: relative;
      z-index: 99;
      padding: 10px;
      max-height: 333px;
      overflow: hidden;
      transition: all 0.3s;
      &.show {
        transition: all 0.3s;
      }
      li {
        display: flex;
        padding: 15px 0;
        cursor: pointer;
        border-bottom: 1px solid #eeeeee;
        &:last-child {
          border-bottom: 0;
        }
        .el-image {
          width: 80px;
          height: 80px;
          margin-right: 15px;
        }
        .cont {
          flex: 1;
          position: relative;
          .name {
            color: #000;
            font-size: 14px;
            padding-bottom: 8px;
          }
          .desc {
            color: #4f4f4f;
            font-size: 12px;
          }
          .bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            .price {
              color: #ff0000;
              font-size: 12px;
              span {
                font-size: 14px;
                padding-left: 5px;
                font-weight: 700;
              }
            }
            .num {
              font-size: 12px;
              color: #000;
            }
          }
        }
      }
    }
    .toggle-box {
      position: relative;
      z-index: 100;
      background: #fff;
      margin-top: -12px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 0;
      font-size: 14px;
      color: #4f4f4f;
      cursor: pointer;
      i {
        margin-left: 4px;
        font-size: 18px;
      }
    }
  }
  .order-info {
    display: flex;
    justify-content: flex-end;
    ul {
      width: 315px;
      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #4f4f4f;
        font-size: 14px;
        padding-bottom: 12px;
        span {
          font-size: 12px;
          padding-right: 4px;
        }
      }
    }
  }
}
.order-bottom {
  padding-bottom: 108px;
  .total-box {
    display: flex;
    justify-content: flex-end;
    padding: 0 30px;
    height: 50px;
    line-height: 50px;
    border: 1px solid #ec9221;
    .name {
      color: #000;
      font-size: 14px;
    }
    .money {
      color: #ff0000;
      font-size: 14px;
      padding-left: 2px;
      span {
        padding-left: 5px;
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
  .action-btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .item-btn {
      text-align: center;
      width: 145px;
      height: 40px;
      line-height: 40px;
      background: #ec9221;
      color: #fff;
      font-size: 18px;
      font-weight: 700;
      cursor: pointer;
    }
  }
}
.pay-dialog {
  /deep/ .el-dialog__headerbtn .el-dialog__close {
    display: none;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  .pay-tips {
    font-size: 14px;
    color: #ff0000;
    padding-bottom: 40px;
  }
  i {
    font-size: 60px;
    font-weight: bold;
    color: #ec9221;
  }
  .loading-text {
    color: #aaa;
    font-size: 14px;
    padding: 10px 0 20px;
  }
  .btn {
    cursor: pointer;
    width: 120px;
    height: 38px;
    line-height: 38px;
    margin: 0 auto;
    background: #ec9221;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
  }
}

/* 选择优惠券 */
.coupon-select {
  border-bottom: 1px solid #eee;
  margin-bottom: 30px;
  padding-bottom: 40px;
  .title {
    color: #000;
    font-size: 14px;
  }
  .coupon-cont {
    cursor: pointer;
  }
  span {
    color: #ff0000;
    font-size: 14px;
    &.tips {
      color: #aaa;
    }
    &.name {
      background-color: #ff0000;
      color: #fff;
      border-radius: 12px;
      height: 18px;
      line-height: 18px;
      padding: 0 12px;
      font-size: 12px;
      margin: 0 20px;
    }
  }
  .el-icon-arrow-right {
    margin-left: 20px;
  }
}
.coupon-list {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  &::after {
    content: ' ';
    width: 315px;
  }
  .item {
    display: flex;
    align-items: center;
    width: 300px;
    height: 68px;
    border-radius: 12px;
    background-color: #fff;
    margin-bottom: 15px;
    padding: 0 15px 0 0;
    box-shadow: 0px 0px 10px 0px #e5eaf1;
    cursor: pointer;
    &.disabeld {
      cursor: not-allowed;
      span,
      div {
        color: #aaa !important;
      }
    }
    .left {
      padding: 0 15px;
      text-align: center;
      .money {
        color: #ff0000;
        font-size: 12px;
        text {
          padding-left: 4px;
          font-size: 20px;
        }
      }
      .fullmoney {
        color: #aaa;
        font-size: 10px;
        padding-top: 4px;
      }
    }
    .right {
      flex: 1;
      .name {
        font-size: 14px;
        color: #000;
      }
      .time {
        color: #aaa;
        font-size: 10px;
        padding-top: 4px;
      }
    }
    .check-box {
      border-color: #aaaaaa;
      &.cur {
        border-color: #ec9221;
      }
    }
  }
}
.coupon-dialog {
  .action-box {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.card-input {
  margin-bottom: 15px;
  &__label {
    color: #4F4F4F;
    font-size: 14px;
    padding-right: 10px;
  }
  &:last-child {
    margin-bottom: 30px;
  }
}
</style>